export const environment = {
  production: true,
  socket: '/websocket/websocket',
  simple: window.location.hostname.startsWith('prices.'),
};
